import { useCallback } from 'react';
import { useAtomCallback } from 'jotai/utils';
import { eventJournalConsumerAtom } from '../atoms/event-journal-atoms';
export function useJournalHandle() {
  const getConsumer = useAtomCallback(useCallback(get => get(eventJournalConsumerAtom), []));
  const drainJournal = useCallback((): Promise<void> => getConsumer()?.consumeAll() ?? Promise.resolve(), [getConsumer]);
  const getPendingJournalCount = useCallback((): Promise<number> => getConsumer()?.getPendingCount() ?? Promise.resolve(0), [getConsumer]);
  return {
    drainJournal,
    getPendingJournalCount
  };
}